<template>
    <v-app v-if="isLoading">
        <loading />
    </v-app>
    <v-card
        v-else
        class="EK-card EK-shadow IMTOrange text-center rounded-xl rounded-tr-0 border-top border-right"
    >
        <v-data-table
            dense
            :headers="headers"
            :items="storeOrderList"
            hide-default-footer
            :search="searchText"
            :items-per-page="10"
            :page.sync="page"
            @page-count="pageCount = $event"
        >
            <template v-slot:top>
                <v-text-field
                    v-model="searchText"
                    color="IMThemeGray"
                    label="بحث في الجدول"
                    append-icon="mdi-magnify"
                    style="width: 280px"
                    class="mx-4"
                ></v-text-field>
            </template>
            <template v-slot:item="{ item, index }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <tr v-on="on"
                            v-bind="attrs"
                            @click="
                            details(
                            item.orderType,
                            storeOrderList.findIndex(
                            contact=>
                            contact.id == item.id
                            ),
                            item.id
                            )
                            "
                            :class="{
                            active: (page - 1) * 10 + index == orderIndex,
                            newOrder: !item.isRead
                            }"
                            >
                            <td>
                                {{ item.shopName }}
                            </td>
                            <td v-if="item.orderType == 1">تحميل صور</td>
                            <td v-else-if="item.orderType == 2">
                                تعديل بيانات
                            </td>
                            <td v-else-if="item.orderType == 3">إشعار</td>
                            <td v-else-if="item.orderType == 4">شكوى/اقتراح</td>
                            <td v-else-if="item.orderType == 5">تحميل عرض</td>
                            <td>
                                {{
                                    new Date(item.createdAt).toLocaleTimeString("ar-GB")
                                    + " " +
                                    new Date(item.createdAt).toISOString().substr(0, 10)
                                }}
                                
                            </td>
                            <td>
                                <router-link :to="`/shop/details/${item.shopId}`">
                                    <v-btn text small>
                                        <img src="/media/svg/aside-icon/shop.svg"
                                             alt="go to shop"
                                             width="22" />
                                    </v-btn>
                                </router-link>
                            </td>
                            <td>
                                <v-icon v-if="item.orderState">mdi-checkbox-marked-circle-outline</v-icon>
                                <v-icon v-else>mdi-close-circle-outline</v-icon>
                            </td>
                            <td>
                                <v-btn @click="
                                        onConfirmDelete(
                                            item.id,
                                            (page - 1) * 10 + index
                                        )
                                    "
                                       text>
                                    <img src="/media/svg/table/delete.svg"
                                         alt="delete" />
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    <span>انقر لعرض التفاصيل</span>
                </v-tooltip>
            </template>
        </v-data-table>
        <v-pagination
            color="IMThemeGray"
            v-model="page"
            :total-visible="7"
            :length="pageCount"
        ></v-pagination>
    </v-card>
</template>
<style lang="scss" scoped>
.active {
    background: rgba(0, 0, 0, 0.125) !important;
}
.newOrder {
    background: #ffddc9 !important;
}
</style>
<script>
import loading from "@/components/loading";
import { mapGetters, mapActions } from "vuex";
export default {
    props: {
        orderIndex: String
    },
    components: {
        loading
    },
    data: () => ({
        page: 1,
        pageCount: 0,
        searchText: "",
        headers: [
            {
                text: "اسم المشترك",
                value: "shopName"
            },
            {
                text: "نوع الطلب",
                value: "orderType"
            },
            {
                text: "تاريخ الطلب",
                value: "createdAt"
            },
         
            {
                text: "رؤية المشترك",
                value: "GoShop",
                sortable: false
            },
            {
                text: "حالة الطلب",
                value: "orderState",
                sortable: false
            },
            {
                text: "حذف",
                value: "delete",
                sortable: false
            }
        ]
    }),
    created() {
        this.$store.dispatch("fetchOrdersStore");
        this.CheckIfOrderRead();
    },
    computed: {
        ...mapGetters(["storeOrderList", "isLoading"])
    },
    methods: {
        ...mapActions([
            "deleteOrdersStore",
            "setReadOrder",
            "CheckIfOrderRead"
        ]),
        onConfirmDelete(id, index) {
            this.deleteOrdersStore({ id, index });
        },
        details(type, index, id) {
            this.setReadOrder(id);
            if (index != this.orderIndex) {
                if (type == 1) {
                    this.$router.push(
                        `/contact/store-order/add-images/${index}`
                    );
                } else if (type == 2) {
                    this.$router.push(
                        `/contact/store-order/edit-info/${index}`
                    );
                } else if (type == 3) {
                    this.$router.push(`/contact/store-order/notify/${index}`);
                } else if (type == 4) {
                    this.$router.push(
                        `/contact/store-order/edit-info/${index}`
                    );
                } else
                    this.$router.push(
                        `/contact/store-order/add-images/${index}`
                    );
            }
        }
    }
};
</script>
